import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { Button } from '@mui/material';
import React from 'react';
export const SubmitHoursButton = ({ children, variant, dialogTitle, dialogContent, submitLabel, shiftStartTime, shiftStopTime, participantShiftStartTime, participantShiftStopTime, startIcon, onSubmit, }) => {
    const addVolunteeringHoursFormConfig = {
        type: 'form',
        children: [
            {
                type: 'form.content',
                html: `<p class="body1">${dialogContent}</p>`,
            },
            {
                type: 'form.dateTimeRangePicker',
                key: 'addHours',
                timeFormat: '12h',
                timeMinuteStep: 1,
                validate: {
                    required: true,
                },
            },
        ],
    };
    return (React.createElement(Button, { variant: variant, startIcon: startIcon, size: 'small', onClick: (event) => {
            event.stopPropagation();
            showFormDialog({
                title: dialogTitle,
                submitLabel: submitLabel,
                maxWidth: 'md',
                config: addVolunteeringHoursFormConfig,
                data: {
                    addHours: {
                        from: participantShiftStartTime !== null && participantShiftStartTime !== void 0 ? participantShiftStartTime : shiftStartTime,
                        to: participantShiftStopTime !== null && participantShiftStopTime !== void 0 ? participantShiftStopTime : shiftStopTime,
                    },
                },
                onSubmit: onSubmit,
            });
        } }, children));
};
